import server from "@config/server";

export async function auth(to, from, next) {
  const token = localStorage.getItem("token");
  return server
    .get(`/authenticate`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(() => {
      return next();
    })
    .catch(() => {
      return next({ name: "login" });
    });
}

export async function authForLogin(to, from, next) {
  const token = localStorage.getItem("token");
  return server
    .get(`/authenticate`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(() => {
      return next({ name: "report" });
    })
    .catch(() => {
      return next();
    });
}
